import { render, staticRenderFns } from "./SendWillForStorage.vue?vue&type=template&id=e590455c"
import script from "./SendWillForStorage.vue?vue&type=script&lang=js"
export * from "./SendWillForStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports